import sadDino from '../assets/logos/honved/honved_vizjel.svg'
import Typography from "@mui/material/Typography";
import Base from "./Base";
import {Stack} from "@mui/material";
import Button from "@mui/material/Button";
import {useHistory} from "react-router-dom";

const NotFound = () => {
    const history = useHistory()
    return <Base>
        <div className="not-found-container">
            <Stack justifyContent="center" alignItems="center" spacing={2}>
                <Typography variant="headline2">Az oldal nem található!</Typography>
                <img src={sadDino} alt="sad dino" style={{width: '100%'}}/>
                <Button variant='contained' onClick={() => history.push('/')}>
                    Vissza a főoldalra
                </Button>
            </Stack>

        </div>
    </Base>

}

export default NotFound